import { CurrencyCode, MoneyFragment, RewardsQuery } from '../../graphql/search'

export type RewardsSnapshot = NonNullable<
  NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
>['nodes'][number]

export const parseRewardsSnapshots = (
  rewardsSnapshots?: RewardsSnapshot[],
): (RewardsSnapshot | undefined)[] => rewardsSnapshots ?? []

export const zeroMoney = (currencyCode: CurrencyCode = CurrencyCode.Usd): MoneyFragment => ({
  amount: '0.00',
  currencyCode,
})

export const isRewardsSnapshotPositiveSales = (rewardsSnapshot?: RewardsSnapshot) =>
  !!rewardsSnapshot &&
  (parseFloat(rewardsSnapshot.sales.total.amount) > 0 || rewardsSnapshot.orderCount > 0)
